import React, { useEffect, useState } from "react";
import { useOutletContext, Link } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import { CreditCard, CheckCircle, Clock, ArrowRight } from "lucide-react";
import "./VendorPayments.css";

const paymentState = (app) => {
  if (app.balance_confirmed) return { label: "Fully paid", tone: "done" };
  if (app.balance_submitted) return { label: "Balance under review", tone: "pending" };
  if (app.deposit_confirmed) return { label: "Deposit confirmed — balance due", tone: "active" };
  if (app.deposit_submitted) return { label: "Deposit under review", tone: "pending" };
  return { label: "Payment required", tone: "due" };
};

const VendorPayments = () => {
  const { vendor } = useOutletContext();
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!vendor?.id) { setLoading(false); return; }

    const load = async () => {
      const { data, error } = await supabase
        .from("vendor_applications")
        .select(`
          id, status, invoice_total, custom_base_price,
          deposit_required, deposit_submitted, deposit_confirmed,
          balance_submitted, balance_confirmed,
          events ( name, event_key )
        `)
        .eq("vendor_id", vendor.id)
        .in("status", ["approved", "accepted"])
        .order("created_at", { ascending: false });

      if (error) console.error("Payments:", error);
      setRows(data || []);
      setLoading(false);
    };

    load();
  }, [vendor?.id]);

  if (loading) return <div className="vp-loading">Loading payments…</div>;

  return (
    <div className="vp-page">
      <div className="vp-header">
        <h1 className="vp-title">Payments</h1>
        <p className="vp-subtitle">Invoice and payment status for every event you've been accepted to.</p>
      </div>

      {rows.length === 0 ? (
        <div className="vp-empty">
          <CreditCard size={20} />
          <p>Nothing to show yet — once you're accepted into an event, its invoice will appear here.</p>
        </div>
      ) : (
        <div className="vp-list">
          {rows.map((app) => {
            const total = Math.round((app.invoice_total ?? app.custom_base_price ?? 0) || 0);
            const state = paymentState(app);

            return (
              <div key={app.id} className="vp-row">
                <div className="vp-row-left">
                  {state.tone === "done" ? <CheckCircle size={16} className="vp-icon-done" /> : <Clock size={16} className="vp-icon-pending" />}
                  <div>
                    <span className="vp-event">{app.events?.name || "Event"}</span>
                    <span className={`vp-status vp-status--${state.tone}`}>{state.label}</span>
                  </div>
                </div>

                <div className="vp-row-right">
                  <span className="vp-total">KES {total.toLocaleString()}</span>
                  {state.tone !== "done" && (
                    <Link to={`/vendor/events/${app.events?.event_key || ""}`} className="vp-link">
                      Manage <ArrowRight size={13} />
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VendorPayments;